





















































































import {Vue, Component, Prop, Watch,Mixins} from 'vue-property-decorator';
import * as letterService from '@/store/Services/letterServices';
import store from '@/store';
import { DependencyTrail, DependencyTreeNode } from '@/store/models/Letter/DependencyTrail';
import DependencyGraphNode from './DependencyGraphNode/DependencyGraphNode.vue';
import DependencyGraphEdg from './DependencyGraphEdg/DependencyGraphEdg.vue';
import LetterTrailTree from '@/components/Cartable/LetterDetails/LetterTrail/LetterTrailTree.vue';
import * as $ from 'jquery';
import * as util from '@/util/utils';
import ComponentMixinBase from '@/components/Cartable/ComponentMixins/ComponentMixinBase';

@Component({
    components:{DependencyGraphNode, DependencyGraphEdg, LetterTrailTree}
})
export default class DependencyGraphContainer extends Mixins(ComponentMixinBase){
    @Prop() letterPossessionId?: string;
    @Prop() letterId?: string;
    @Prop() letterNo?: string;
    dependencyTrail: DependencyTrail = {} as DependencyTrail;
    zoom = 100;
    @Watch("letterPossessionId")
    onPossessionIdChanged()
    {
        this.refreshTree();
        if(this.letterId)
            this.selectedLetterId = this.letterId;
        if(this.letterNo)
            this.selectedLetterNo = this.letterNo;
    }
    async created(){
        this.refreshTree();
        if(this.letterId)
            this.selectedLetterId = this.letterId;
        if(this.letterNo)
            this.selectedLetterNo = this.letterNo;
    }

    mounted(){
         if(this.isMobile()){
            $('.dependencyGraph').sidebar({
            context: $('.bottom.segment')
            ,closable:false
          }).sidebar('attach events','.dependencyGraphsidebarButton')
          .sidebar('setting', 'mobileTransition', 'overlay')
            .sidebar('toggle');
        }else{
                  $('.dependencyGraph').sidebar({
            context: $('.bottom.segment'),
          }).sidebar('attach events','.dependencyGraphsidebarButton')
          .sidebar('setting', 'transition', 'overlay')
            .sidebar('toggle');
        }
           
    }

    selectedLetterId = "";
    selectedLetterNo = "";
    mountedCount = 0;
    onNodeMounted(){
        this.mountedCount++;
        if(this.mountedCount == this.nodesCount)
        {
            this.placeNodes();
        }
    }

    async refreshTree(){
        this.maxTreeLevel = 0;
        this.levelList = [] as string[][];
        this.levelSumWidth = [] as number[];
        this.nodePositions = [];
        if(!this.letterPossessionId)return;
        const ownerId =  store.state.ownerId;
        this.dependencyTrail = await letterService.getDependencyTrail(ownerId,this.letterPossessionId);
        console.log(this.dependencyTrail);
        (this.$refs.page as any).addEventListener('contextmenu',this.cancel);
        this.createDependencyTree();
    }
    cancel(e: Event){
        e.preventDefault();
    }

    close(){
        this.$emit("close");
    }

    onPageClick(e: MouseEvent){
      
        e.stopPropagation();
        if( e.button ==0){
            const x = e.clientX - (this.$refs.page as any).offsetLeft;
            const y = e.clientY - (this.$refs.page as any).offsetTop;
            if(this.lastClickedLetterId != "")
            {
                const position =  this.nodePositions.find(p=>p.letterId === this.lastClickedLetterId);
                if(position){
                    position.x = x;
                    position.y = y;
                }
            }
            store.state.eventHub.$emit("page-clicked",this.lastClickedLetterId,x,y);
           
        }
        this.lastClickedLetterId = '';
        this.isMovingNode = false;
        store.state.eventHub.$emit("unselect-all");

        this.lines = [];
        this.drawLinesRecursive(this.root);
      
        
    }
    lastClickedLetterId = '';
    isMovingNode = false;
    
    onGraphNodeDblClicked(letterId: string){
        this.lastClickedLetterId = letterId;
        this.isMovingNode = true;
    }
    onGraphNodeClicked(nodeInfo: any){
        this.selectedLetterId = nodeInfo.letterId;
        this.selectedLetterNo = nodeInfo.letterNo;
        if(this.isMobile()){
            // $('.dependencyGraph')
            // .sidebar('setting', 'mobileTransition', 'overlay')
            // .sidebar('toggle')
            console.log('this is a test')
        }else{
            $('.dependencyGraph')
            .sidebar('setting', 'transition', 'overlay')
            .sidebar('toggle')
        }
    }
    nodesCount = 0;
    createDependencyTree(){
        if(!this.dependencyTrail)return;
        if(!this.dependencyTrail.dependencyGraph)return;
        if(!this.dependencyTrail.letters)return;
        const sqrt = Math.sqrt(this.dependencyTrail.dependencyGraph.length) - 1;
        this.nodesCount = sqrt;
        let rootIndex = -1;
        for(let i =0 ;i <= sqrt; i++)
        {
            for(let j = 0; j<=sqrt; j++)
            {
                if(this.dependencyTrail.dependencyGraph[((i*sqrt) + (i+j))] != null)
                    break;
                if(j === sqrt)
                    rootIndex = i;
            }
            if(rootIndex !== -1)break;
        }
        this.root = {} as DependencyTreeNode;
        this.root.letterId = this.dependencyTrail.letters[rootIndex].letterId;
        this.root.level = 0;
        this.root.childs = [];
        this.root.childType = [];
        this.addNodToTreeRecursive(this.root,rootIndex,sqrt);
        for(let i = 0;i <=this.maxTreeLevel;i++)
        {
            this.levelList[i] = [];
            this.levelSumWidth[i] = 0;
        }
        this.flatTreeRecursive(this.root);
        
        
    }
    root: DependencyTreeNode = {} as DependencyTreeNode;
    maxTreeLevel = 0;
    levelList = [] as string[][];
    levelSumWidth = [] as number[];
    nodePositions: NodePosition[] = [] as NodePosition[];
    addNodToTreeRecursive(parent: DependencyTreeNode, index: number,sqrt: number){
        if(!this.dependencyTrail)return;
        if(!this.dependencyTrail.letters)return;
        if(!this.dependencyTrail.dependencyGraph)return;
        let currentIndex = index; 
        for(let rowIndex = 0;rowIndex <= sqrt;rowIndex++)
        {
            if(this.dependencyTrail.dependencyGraph[currentIndex] != null){
                const child = {} as DependencyTreeNode;
                child.letterId = this.dependencyTrail.letters[rowIndex].letterId;
                child.level = parent.level+ 1;
                if(child.level > this.maxTreeLevel) this.maxTreeLevel = child.level;
                child.childs = [];
                child.childType = [];
                parent.childs.push(child);
                parent.childType.push(this.dependencyTrail.dependencyGraph[currentIndex]);
                this.addNodToTreeRecursive(child,rowIndex,sqrt);
            }
            currentIndex += sqrt +1;
            
        }
    }
    flatTreeRecursive(node: DependencyTreeNode){
        this.levelList[node.level].push(node.letterId);
        node.childs.forEach(c=>this.flatTreeRecursive(c));
    }
    exposedCount = 0;
    onExposeWidth(width: number, level: number){
        this.levelSumWidth[level] += width + 40; // 40 px between each node
        this.exposedCount++;
      
    }
    isFirstUpdate = false;
    maxLevelWidth = 0;
    get marginMakerTop(){
        return  `${this.maxTreeLevel * 200}px`;
    }
    

    placeNodes(){
        for(let i = 0;i <=this.maxTreeLevel;i++)
        {
            this.levelSumWidth[i] = 0;
        }
        for(let i = 0;i <=this.maxTreeLevel;i++)
        {
            this.levelList[i].forEach(letterId=>store.state.eventHub.$emit("get-width",letterId,i));
        }
        this.maxLevelWidth = 0;
        this.levelSumWidth.forEach(w=> {
            if(w > this.maxLevelWidth)this.maxLevelWidth = w;
        });
        this.setNodesPosition();
        this.lines = [];
        this.drawLinesRecursive(this.root);
    }
   

    lines: Line[] = [] ;
    drawLinesRecursive(node: DependencyTreeNode)
    {
        node.childs.forEach(c=>{
            const nodePosition =  this.nodePositions.find(p=>p.letterId === node.letterId);
            const childPosition = this.nodePositions.find(p=>p.letterId === c.letterId);
            if(nodePosition && childPosition){
                const  start = {} as Point;
                start.x = nodePosition.x + 50;
                start.y = nodePosition.y + 50;
                const  end = {} as Point;
                end.x = childPosition.x + 50;
                end.y = childPosition.y + 50;
                const line = {} as Line;
                line.start = start;
                line.end = end;
                line.id = util.getNewGuid();
                this.lines.push(line);
            }
            this.drawLinesRecursive(c);
        });
    }

    setNodesPosition(){
        
        for(let i = 0;i <=this.maxTreeLevel;i++)
        {
            store.state.eventHub.$emit("removeAllEdges");
            let x = 0;
            const y = (i * 150) + 10;
            const leftMargin = (this.maxLevelWidth - this.levelSumWidth[i])/2 + 50;
            x = leftMargin;
            this.levelList[i].forEach(letterId=>{
                let position =  this.nodePositions.find(p=>p.letterId === letterId);
                if(!position){
                    position = {} as NodePosition;
                    position.letterId = letterId;
                    position.x = x;
                    position.y = y;
                    this.nodePositions.push(position);
                }
                store.state.eventHub.$emit("set-position",letterId,position.x,position.y);
                x += this.levelSumWidth[i]/this.levelList[i].length
            });
        }
    }
    
    onEdgRemove(edg: Vue){
        console.log(edg);
        this.$el.removeChild(edg.$el);
    }
    
}

interface  NodePosition {
    letterId: string;
    x: number;
    y: number;
}

interface Point{
    x: number;
    y: number;
}

export interface Line
{
    id: string;
    start: Point;
    end: Point;
}

